export const useStyles = () => {
  return {
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      paddingTop: '8px',
      paddingBottom: '16px',
      '@media (max-width: 1023px)': {
        paddingTop: '6px',
        paddingBottom: '12px',
      },
      '@media (max-width: 767px)': {
        paddingTop: '4px',
        paddingBottom: '10px',
      },
      '@media (max-width: 480px)': {
        paddingTop: '2px',
        paddingBottom: '8px',
      },
    },
    columnsContainer: {
      display: 'flex',
      gap: '40px',
      width: '100%',
      justifyContent: 'space-between',
      flex: 1,
      position: 'relative',
      '@media (max-width: 1023px)': {
        gap: '24px',
      },
      '@media (max-width: 767px)': {
        flexDirection: 'column',
        gap: '16px',
      },
    },
    columnDivider: {
      position: 'absolute',
      left: '50%',
      top: 0,
      bottom: 0,
      width: '1px',
      backgroundColor: 'rgba(255, 255, 255, 0.20)',
      transform: 'translateX(-50%)',
      '@media (max-width: 767px)': {
        display: 'none',
      },
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      flex: 1,
      '@media (max-width: 1023px)': {
        gap: '12px',
      },
      '@media (max-width: 767px)': {
        gap: '10px',
      },
      '@media (max-width: 480px)': {
        gap: '8px',
      },
    },
    optionRow: {
      display: 'flex',
      padding: '0px 1px',
      alignItems: 'center',
      gap: '12px',
      alignSelf: 'stretch',
      cursor: 'pointer',
      '@media (max-width: 767px)': {
        gap: '10px',
        padding: '2px 1px',
      },
      '@media (max-width: 480px)': {
        gap: '8px',
      },
    },
    checkbox: {
      color: '#FFF',
      padding: 0,
      '&.Mui-checked': {
        color: '#FFF',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '24px',
        '@media (max-width: 767px)': {
          fontSize: '20px',
        },
        '@media (max-width: 480px)': {
          fontSize: '18px',
        },
      },
      '& .MuiTouchRipple-root': {
        display: 'none',
      },
    },
    optionText: {
      color: '#FFF',
      fontFamily: 'Noto Sans',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: '140%',
      textAlign: 'left',
      flex: 1,
      '@media (max-width: 1023px)': {
        fontSize: '13px',
      },
      '@media (max-width: 767px)': {
        fontSize: '12px',
      },
      '@media (max-width: 480px)': {
        fontSize: '11px',
      },
    },
  };
};

